const _require = require('lodash'),
  isPlainObject = _require.isPlainObject;
const _require2 = require('../../lib/evaluateSource'),
  evaluateSource = _require2.evaluateSource;
const _require3 = require('../../lib/irtc/assignmentGroups'),
  getAssignmentGroups = _require3.getAssignmentGroups,
  processAssignments = _require3.processAssignments;

/**
  * @function evalute - evaluate itiAssignmentGroupsBehavior
  */

const evaluate = async (source, content, parentContentPath, transientContext, nativeFunctions) => {
  const assignmentGroups = getAssignmentGroups();
  const checklists = await evaluateSource(source.checklists, content, parentContentPath, transientContext, nativeFunctions);
  if (checklists === undefined || !isPlainObject(checklists)) {
    return assignmentGroups;
  }
  processAssignments(checklists, (identifier, plusOpen, plusComplete) => {
    if (identifier !== undefined) {
      const item = assignmentGroups[identifier] || {};
      const _item$open = item.open,
        open = _item$open === void 0 ? 0 : _item$open,
        _item$complete = item.complete,
        complete = _item$complete === void 0 ? 0 : _item$complete;
      item.open = open + plusOpen;
      item.complete = complete + plusComplete;
    }
  });
  Object.keys(assignmentGroups).forEach(key => {
    const value = assignmentGroups[key];
    if (value.open > 0 || value.complete > 0) {
      value.subtitle = "Open: ".concat(value.open, " Complete: ").concat(value.complete);
      delete value.open;
      delete value.complete;
    } else {
      delete assignmentGroups[key];
    }
  });
  return assignmentGroups;
};
module.exports = {
  evaluate
};